import React from 'react';
import { useSelector } from "react-redux";

const PreHeaderLinks = () => {
    const preHeaderLinks = useSelector((state) => state.navigation.preLinkList);

    if (preHeaderLinks == null) {
        return null;
    }

    if (preHeaderLinks?.length === 0) {
        return null;
    }

    return <div className="navbar__link__pre-header-links hide-desktop">
        <ul className="pre-header-link-list">
            {preHeaderLinks.map((link, index) => (
                <li key={`pre-header-link-${index}`}>
                    <a
                        className="navbar__link navbar__link__pre-header-links__link"
                        href={link.href}
                        dangerouslySetInnerHTML={{ __html: link.text }}
                    ></a>
                </li>
            ))}
        </ul>
    </div>;
};

export default PreHeaderLinks;
